/**
 * Storefront mirror of apps/api/src/products/prices/synthesizePriceFromLegacy.ts
 * — the server is the authority; this file follows it.
 *
 * TODO(M14): delete once the prices[] backfill has run on production and every
 * product carries a prices[] array.
 *
 * A THIRD variant lives at
 * apps/dashboard/src/dashboard/scenes/PageEdit/scenes/PageProduct/lib/synthesizePriceFromLegacy.js
 * and is deliberately NOT unified with this one: it emits decimal-dollar
 * strings and Formik-friendly defaults (interval 'month', '' instead of
 * undefined) for the price editor. Only this mirror and the server's are
 * outcome-compatible.
 *
 * What the server emits and this mirror does not, because no storefront
 * payload carries the inputs and no consumer reads the outputs:
 * `hasBeenPurchased` (chargeCount / subscribers are withheld from client
 * payloads), the stripe price ids (write-path only), and
 * trialPeriodDays / billingCycleAnchorConfig / startDate (a bump rides the
 * primary's subscription and never carries its own).
 */
export default function synthesizePriceFromLegacy(product) {
  const billingType = product.type === 'subscription' ? 'recurring' : 'one_time';

  const price = {
    // The server derives the same id from the same hex (ObjectId(hex) is
    // identity for a 24-char string), so the two mirrors agree.
    _id: String(product._id),
    enabled: true,
    billingType,
    amount: product.pricingType === 'multiple' ? 0 : (product.price ?? 0),
    currency: product.currency || 'usd',
    discountedFromPrice: (() => {
      if (product.discountedFromPrice == null || product.discountedFromPrice === '') {
        return undefined;
      }
      const amount = Number(product.discountedFromPrice);
      return Number.isFinite(amount) ? amount : undefined;
    })(),
    payWhatYouWant: !!product.payWhatYouWant,
    pwywSuggestedPrice: 0,
    setupFee: product.setupFee ?? undefined,
  };

  if (billingType === 'recurring') {
    const config = {
      interval: product.interval || undefined,
      intervalCount: product.intervalCount ?? undefined,
    };
    if (product.planIterations != null && product.planIterations > 0) {
      price.paymentPlan = { ...config, planIterations: product.planIterations };
    } else {
      price.recurring = config;
    }
  }

  return price;
}

export { synthesizePriceFromLegacy };
